import { UseMutationOptions, useMutation } from 'react-query';
import { HTTPBoundSchemaMethod, SchemaIO } from '@frontend/schema';
import { SchemaAuthService } from './api';

type SchemaMutationOptions<T extends HTTPBoundSchemaMethod<any>> = UseMutationOptions<
  SchemaIO<T>['output'],
  unknown,
  SchemaIO<T>['input'],
  unknown
>;

export const useAddContact = (opts: SchemaMutationOptions<(typeof SchemaAuthService)['AddContact']> = {}) =>
  useMutation({
    mutationKey: 'AddContact',
    mutationFn: SchemaAuthService.AddContact,
    ...opts,
  });

export const useEnableMFA = (opts: SchemaMutationOptions<(typeof SchemaAuthService)['EnableMFA']> = {}) =>
  useMutation({
    mutationKey: 'EnableMFA',
    mutationFn: SchemaAuthService.EnableMFA,
    ...opts,
  });

export const useDisableMFA = (opts: SchemaMutationOptions<(typeof SchemaAuthService)['DisableMFA']> = {}) =>
  useMutation({
    mutationKey: 'DisableMFA',
    mutationFn: SchemaAuthService.DisableMFA,
    ...opts,
  });

export const useValidateContact = (opts: SchemaMutationOptions<(typeof SchemaAuthService)['ValidateContact']> = {}) =>
  useMutation({
    mutationKey: 'ValidateContact',
    mutationFn: SchemaAuthService.ValidateContact,
    ...opts,
  });

export const useDeleteContact = (opts: SchemaMutationOptions<(typeof SchemaAuthService)['DeleteContact']> = {}) =>
  useMutation({
    mutationKey: 'DeleteContact',
    mutationFn: SchemaAuthService.DeleteContact,
    ...opts,
  });

export const useMakeContactPrimary = (
  opts: SchemaMutationOptions<(typeof SchemaAuthService)['MakeContactPrimary']> = {}
) =>
  useMutation({
    mutationKey: 'MakeContactPrimary',
    mutationFn: SchemaAuthService.MakeContactPrimary,
    ...opts,
  });

export const useResendContactValidation = (
  opts: SchemaMutationOptions<(typeof SchemaAuthService)['ResendContactValidation']> = {}
) =>
  useMutation({
    mutationKey: 'ResendContactValidation',
    mutationFn: SchemaAuthService.ResendContactValidation,
    ...opts,
  });
